window.addDebug = function addDebug(debugData) {
  console.log(debugData); // eslint-disable-line no-console
};
